/** CGReact信号插槽机制的信号类，可以将时间灵活绑定到多个目标端*/
import {CGReactSlot} from "./cgreact-slot";

export default class CGReactSignal<DATATYPE, CALL extends string>
{
    private CallKey: string;
    private SlotArray: Array<CGReactSlot<DATATYPE, CALL>> = [];

    constructor(key: CALL)
    {
        this.CallKey = key;
    }

    public bind(slot: CGReactSlot<DATATYPE, CALL>, binder?: object)
    {
        slot["This"] = binder ? binder : slot;
        this.SlotArray.push(slot);
    }

    public unbind(slot: CGReactSlot<DATATYPE, CALL>)
    {
        let index = this.SlotArray.indexOf(slot);
        if (index >= 0)
        {
            this.SlotArray.splice(index, 1);
        }
    }

    public emit(data: DATATYPE)
    {
        this.SlotArray.map(cur => cur[this.CallKey].call(cur["This"], data));
    }
}
